module.exports = __webpack_public_path__ + "img/1799.e44a6036.jpg";